import { Http } from '@diritto/common/utils/requester/http';
import { ShortUrlCreateDto, ShortUrlResponseDto } from '@diritto/common/shortUrl/dtos/short-url.dtos';

export class ShortUrlApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async create(url: string) {
    const res = await this.http.post<ShortUrlCreateDto, ShortUrlResponseDto>(`${this.url}/short-urls/`, {
      url,
    });
    return res.data;
  }
}
